module.exports = __webpack_public_path__ + "img/home-delivery-date-top-img_medium@2x.1558f44a.webp";